module.exports = __webpack_public_path__ + "OpenSans-Semibold.0ea04502930623aa3de1.eot";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Semibold/OpenSans-Semibold.eot
// module id = ../../../../npm-font-open-sans/fonts/Semibold/OpenSans-Semibold.eot
// module chunks = styles